import type React from 'react';
import { useContext } from 'react';
import { observer } from 'mobx-react';

import { TabsContext } from './TabbedPage';

interface TabWindowProps {
  /**
   * Mapping from tab label to the corresponding tab content.
   */
  contentMap: Map<string, () => JSX.Element>;
}

const TabContent: React.FC<TabWindowProps> = (props) => {
  const { contentMap } = props;
  const tabs = useContext(TabsContext);

  if (tabs?.currentTabLabel === undefined) {
    return null;
  }

  return contentMap.get(tabs.currentTabLabel)?.() || null;
};

export default observer(TabContent);
